import { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";

const HeroSection = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center bg-brand-bg-dark overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.prod-images.emergentagent.com/jobs/59dfc951-b411-40b8-8d6f-2feb48798dd5/images/c78fe81d14ed0325727ff9bb4fe1cf38b0df02f38ea91ab4e64315f9de2ecea8.png"
          alt="Sartaj Majestic Basmati Rice"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg-dark via-brand-bg-dark/90 to-brand-bg-dark/60" />
      </div>

      {/* Grain texture */}
      <div className="absolute inset-0 grain-overlay" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Text */}
          <div className={`space-y-8 ${visible ? "animate-fade-up" : "opacity-0"}`}>
            <p className="text-xs uppercase tracking-[0.3em] font-body font-semibold text-brand-gold">
              Purveyors of Finest Basmati
            </p>
            <h1 className="font-heading text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-none text-brand-text-light">
              The Art of
              <br />
              <span className="text-brand-gold italic">Perfect</span> Rice
            </h1>
            <p className="font-body text-base md:text-lg font-light leading-relaxed text-brand-text-light/70 max-w-lg">
              For 25 years, Sartaj has been delivering the world's finest
              basmati rice to discerning tables. Each grain tells a story of
              dedication, expertise, and uncompromising quality.
            </p>
            <div className="flex items-center gap-6 pt-4">
              <a
                href="#collection"
                data-testid="hero-explore-btn"
                className="inline-flex items-center gap-3 px-8 py-4 bg-brand-gold text-brand-primary text-xs uppercase tracking-[0.2em] font-body font-semibold hover:bg-brand-gold-light transition-colors duration-300"
              >
                Explore Our Range
              </a>
              <a
                href="#story"
                data-testid="hero-story-btn"
                className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-brand-gold font-body font-medium gold-underline"
              >
                Our Story
              </a>
            </div>
          </div>

          {/* Right: Hero Image */}
          <div
            className={`hidden lg:flex justify-end ${
              visible ? "animate-slide-in-right" : "opacity-0"
            }`}
          >
            <div className="relative">
              <div className="border border-brand-gold/20 p-2">
                <img
                  src="https://static.prod-images.emergentagent.com/jobs/59dfc951-b411-40b8-8d6f-2feb48798dd5/images/c78fe81d14ed0325727ff9bb4fe1cf38b0df02f38ea91ab4e64315f9de2ecea8.png"
                  alt="Sartaj Majestic Basmati"
                  data-testid="hero-image"
                  className="w-[420px] h-[520px] object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-brand-gold px-6 py-3">
                <span className="font-heading text-brand-primary text-sm italic">
                  Est. 2000
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.3em] text-brand-text-light/40 font-body">
          Scroll
        </span>
        <ChevronDown size={16} className="text-brand-gold/60 animate-bounce" />
      </div>
    </section>
  );
};

export default HeroSection;
